var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHurtsWorstUnselected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    clipPath: "url(#clip0_319_1383)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 35C28.2843 35 35 28.2843 35 20C35 11.7157 28.2843 5 20 5C11.7157 5 5 11.7157 5 20C5 28.2843 11.7157 35 20 35Z",
    fill: "#EE664E",
    stroke: "#EE664E",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8974 21.0004C15.5004 21.0004 16.8 19.661 16.8 18.0088C16.8 16.8892 16.2032 15.9133 15.3196 15.4004L11.2 19.1157C11.6269 20.22 12.6737 21.0004 13.8974 21.0004Z",
    fill: "#731C0C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1026 21.0004C24.4996 21.0004 23.2 19.661 23.2 18.0088C23.2 16.8892 23.7968 15.9133 24.6804 15.4004L28.8 19.1157C28.3731 20.22 27.3263 21.0004 26.1026 21.0004Z",
    fill: "#731C0C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 27.1C28 27.9837 27.2837 28.7 26.4 28.7C25.5164 28.7 24.8 27.9837 24.8 27.1C24.8 26.2163 25.5164 22.5 26.4 22.5C27.2837 22.5 28 26.2163 28 27.1Z",
    fill: "#731C0C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3721 24.5522C22.3287 23.9261 21.1728 23.5996 20 23.5996C18.8272 23.5996 17.6713 23.9261 16.6279 24.5522C15.5845 25.1782 14.6837 26.0857 14 27.1996",
    stroke: "#731C0C",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3767 13.7838C26.7344 15.3374 27.6825 15.8848 29.7068 16.2838",
    stroke: "#731C0C",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6201 13.7838C13.2624 15.3374 12.3143 15.8848 10.29 16.2838",
    stroke: "#731C0C",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_319_1383"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHurtsWorstUnselected);
export default __webpack_public_path__ + "static/media/hurts-worst-unselected.1c28e610fe0cb73359fc5c9442005529.svg";
export { ForwardRef as ReactComponent };